module.exports = __webpack_public_path__ + "media/images/email/postmark-d2c4a8ddd7d1520a79ffd2d82d3e3d39.gif";